import React, { useState,useRef } from 'react';
import TopBar from '../Tools/Topbar';
import LeftSide from '../Tools/LeftSidebar';
import Pagination from '../Tools/Pagination'; // ✅ Custom pagination
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';
import axiosInstance from '../../../api';

const Alarms = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
 

  // Sample alarms data
  const [alarms, setAlarms] = useState([
    {
      time: '5 min ago',
      severity: 'High',
      message: 'Low stock: Resource A (2 left)',
      type: 'Low Stock',
      status: 'Unacknowledged',
      action: 'Acknowledge'
    },
    {
      time: '12 min ago',
      severity: 'High',
      message: 'Dependency failure: Database Cluster',
      type: 'System Failure',
      status: 'Acknowledged',
      action: 'View'
    },
    {
      time: '1 hr ago',
      severity: 'Medium',
      message: 'High CPU load: Server X (95%)',
      type: 'Utilization',
      status: 'Unacknowledged',
      action: 'Acknowledge'
    },
    {
      time: '2 hrs ago',
      severity: 'Info',
      message: 'Maintenance scheduled for Generator Unit',
      type: 'Maintenance',
      status: 'Acknowledged',
      action: 'View'
    },
    
  ]);

  // ✅ Pagination logic
  const [page, setPage] = useState(1);
  const limit = 10; // Show 2 alarms per page
  const total = alarms.length;
  const paginatedAlarms = alarms.slice((page - 1) * limit, page * limit);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
const {settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();
  return (
    <div id="main-wrapper">
      <LeftSide isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <TopBar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
           <Settings 
            ref={settingsRef}
            updateSetting={updateSetting}
            handleColorTheme={handleColorTheme}
            settings={settings}  // Add this line
          />
            <div className="card w-100 position-relative overflow-hidden">
              <div className="px-4 py-3">
                <h5 className="card-title fw-semibold mb-0 lh-sm">System Alarms</h5>
                <p className="card-subtitle mb-0 mt-1">View and manage real-time alerts related to resource health and availability</p>
              </div>

              <div className="card-body p-4">
                {/* Filter Panel */}
                <div className="filter-search">
                  <h6 className="px-2 mb-0">Filter</h6>
                  <div className="filter-panel w-100">
                    <form className="w-100 d-flex flex-wrap">
                      {['Severity', 'Alert Type', 'Time Range', 'Acknowledged'].map((label, index) => (
                        <div key={index} className="form-group col-sm-6 col-lg-auto p-2">
                          <label>{label}</label>
                          <select className="form-control form-select">
                            <option>{label === 'Severity' ? 'Critical' : label === 'Alert Type' ? 'Low stock' : label === 'Time Range' ? 'Today' : 'All'}</option>
                          </select>
                        </div>
                      ))}
                      <div className="form-group col-sm-6 col-lg-auto p-2">
                        <button type="button" className="btn w-100 waves-effect waves-light btn-rounded btn-outline-primary">Search</button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Table */}
                <div className="py-3 px-0">
                  <div className="table-responsive rounded-2 ros-table">
                    <table className="table text-nowrap customize-table mb-0 align-middle">
                      <thead className="text-dark fs-4">
                        <tr>
                          {['Time', 'Severity', 'Message', 'Type', 'Status', 'Action'].map((heading, i) => (
                            <th key={i}><h6 className="fw-semibold mb-0">{heading}</h6></th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedAlarms.map((alarm, index) => (
                          <tr key={index}>
                            <td><p className="mb-0 fw-normal">{alarm.time}</p></td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <span className={`round-8 me-2 d-inline-block rounded-circle ${
                                  alarm.severity === 'High'
                                    ? 'text-bg-danger'
                                    : alarm.severity === 'Medium'
                                    ? 'text-bg-warning'
                                    : 'text-bg-success'
                                }`}></span>
                                {alarm.severity}
                              </p>
                            </td>
                            <td><p className="mb-0 fw-normal">{alarm.message}</p></td>
                            <td><p className="mb-0 fw-normal">{alarm.type}</p></td>
                            <td><p className="mb-0 fw-normal">{alarm.status}</p></td>
                            <td>
                              <a href="#" className="mb-0 fw-normal text-primary">{alarm.action}</a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                <Pagination
                total={total}
                limit={10}
                page={page}
                onPageChange={handlePageChange}
              />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dark-transparent sidebartoggler" onClick={toggleSidebar}></div>
    </div>
  );
};

export default Alarms;
